// Indicatifs téléphoniques internationaux (tous pays)
export const countryCodes = [
  { name: "France", dial: "+33", iso: "FR", flag: "🇫🇷" },
  { name: "Monaco", dial: "+377", iso: "MC", flag: "🇲🇨" },
  { name: "Belgique", dial: "+32", iso: "BE", flag: "🇧🇪" },
  { name: "Suisse", dial: "+41", iso: "CH", flag: "🇨🇭" },
  { name: "Luxembourg", dial: "+352", iso: "LU", flag: "🇱🇺" },
  { name: "Italie", dial: "+39", iso: "IT", flag: "🇮🇹" },
  { name: "Espagne", dial: "+34", iso: "ES", flag: "🇪🇸" },
  { name: "Portugal", dial: "+351", iso: "PT", flag: "🇵🇹" },
  { name: "Royaume-Uni", dial: "+44", iso: "GB", flag: "🇬🇧" },
  { name: "Irlande", dial: "+353", iso: "IE", flag: "🇮🇪" },
  { name: "Allemagne", dial: "+49", iso: "DE", flag: "🇩🇪" },
  { name: "Autriche", dial: "+43", iso: "AT", flag: "🇦🇹" },
  { name: "Pays-Bas", dial: "+31", iso: "NL", flag: "🇳🇱" },
  { name: "Danemark", dial: "+45", iso: "DK", flag: "🇩🇰" },
  { name: "Suède", dial: "+46", iso: "SE", flag: "🇸🇪" },
  { name: "Norvège", dial: "+47", iso: "NO", flag: "🇳🇴" },
  { name: "Finlande", dial: "+358", iso: "FI", flag: "🇫🇮" },
  { name: "Islande", dial: "+354", iso: "IS", flag: "🇮🇸" },
  { name: "Pologne", dial: "+48", iso: "PL", flag: "🇵🇱" },
  { name: "Tchéquie", dial: "+420", iso: "CZ", flag: "🇨🇿" },
  { name: "Slovaquie", dial: "+421", iso: "SK", flag: "🇸🇰" },
  { name: "Hongrie", dial: "+36", iso: "HU", flag: "🇭🇺" },
  { name: "Roumanie", dial: "+40", iso: "RO", flag: "🇷🇴" },
  { name: "Bulgarie", dial: "+359", iso: "BG", flag: "🇧🇬" },
  { name: "Grèce", dial: "+30", iso: "GR", flag: "🇬🇷" },
  { name: "Croatie", dial: "+385", iso: "HR", flag: "🇭🇷" },
  { name: "Slovénie", dial: "+386", iso: "SI", flag: "🇸🇮" },
  { name: "Serbie", dial: "+381", iso: "RS", flag: "🇷🇸" },
  { name: "Ukraine", dial: "+380", iso: "UA", flag: "🇺🇦" },
  { name: "Russie", dial: "+7", iso: "RU", flag: "🇷🇺" },
  { name: "Turquie", dial: "+90", iso: "TR", flag: "🇹🇷" },
  { name: "Chypre", dial: "+357", iso: "CY", flag: "🇨🇾" },
  { name: "Malte", dial: "+356", iso: "MT", flag: "🇲🇹" },
  { name: "Andorre", dial: "+376", iso: "AD", flag: "🇦🇩" },
  { name: "États-Unis", dial: "+1", iso: "US", flag: "🇺🇸" },
  { name: "Canada", dial: "+1", iso: "CA", flag: "🇨🇦" },
  { name: "Mexique", dial: "+52", iso: "MX", flag: "🇲🇽" },
  { name: "Brésil", dial: "+55", iso: "BR", flag: "🇧🇷" },
  { name: "Argentine", dial: "+54", iso: "AR", flag: "🇦🇷" },
  { name: "Chili", dial: "+56", iso: "CL", flag: "🇨🇱" },
  { name: "Colombie", dial: "+57", iso: "CO", flag: "🇨🇴" },
  { name: "Pérou", dial: "+51", iso: "PE", flag: "🇵🇪" },
  { name: "Maroc", dial: "+212", iso: "MA", flag: "🇲🇦" },
  { name: "Algérie", dial: "+213", iso: "DZ", flag: "🇩🇿" },
  { name: "Tunisie", dial: "+216", iso: "TN", flag: "🇹🇳" },
  { name: "Égypte", dial: "+20", iso: "EG", flag: "🇪🇬" },
  { name: "Sénégal", dial: "+221", iso: "SN", flag: "🇸🇳" },
  { name: "Côte d'Ivoire", dial: "+225", iso: "CI", flag: "🇨🇮" },
  { name: "Cameroun", dial: "+237", iso: "CM", flag: "🇨🇲" },
  { name: "Nigéria", dial: "+234", iso: "NG", flag: "🇳🇬" },
  { name: "Afrique du Sud", dial: "+27", iso: "ZA", flag: "🇿🇦" },
  { name: "Émirats Arabes Unis", dial: "+971", iso: "AE", flag: "🇦🇪" },
  { name: "Arabie Saoudite", dial: "+966", iso: "SA", flag: "🇸🇦" },
  { name: "Qatar", dial: "+974", iso: "QA", flag: "🇶🇦" },
  { name: "Koweït", dial: "+965", iso: "KW", flag: "🇰🇼" },
  { name: "Israël", dial: "+972", iso: "IL", flag: "🇮🇱" },
  { name: "Liban", dial: "+961", iso: "LB", flag: "🇱🇧" },
  { name: "Inde", dial: "+91", iso: "IN", flag: "🇮🇳" },
  { name: "Chine", dial: "+86", iso: "CN", flag: "🇨🇳" },
  { name: "Japon", dial: "+81", iso: "JP", flag: "🇯🇵" },
  { name: "Corée du Sud", dial: "+82", iso: "KR", flag: "🇰🇷" },
  { name: "Singapour", dial: "+65", iso: "SG", flag: "🇸🇬" },
  { name: "Thaïlande", dial: "+66", iso: "TH", flag: "🇹🇭" },
  { name: "Malaisie", dial: "+60", iso: "MY", flag: "🇲🇾" },
  { name: "Indonésie", dial: "+62", iso: "ID", flag: "🇮🇩" },
  { name: "Philippines", dial: "+63", iso: "PH", flag: "🇵🇭" },
  { name: "Vietnam", dial: "+84", iso: "VN", flag: "🇻🇳" },
  { name: "Hong Kong", dial: "+852", iso: "HK", flag: "🇭🇰" },
  { name: "Australie", dial: "+61", iso: "AU", flag: "🇦🇺" },
  { name: "Nouvelle-Zélande", dial: "+64", iso: "NZ", flag: "🇳🇿" },
  { name: "Albanie", dial: "+355", iso: "AL", flag: "🇦🇱" },
  { name: "Arménie", dial: "+374", iso: "AM", flag: "🇦🇲" },
  { name: "Azerbaïdjan", dial: "+994", iso: "AZ", flag: "🇦🇿" },
  { name: "Géorgie", dial: "+995", iso: "GE", flag: "🇬🇪" },
  { name: "Biélorussie", dial: "+375", iso: "BY", flag: "🇧🇾" },
  { name: "Bosnie-Herzégovine", dial: "+387", iso: "BA", flag: "🇧🇦" },
  { name: "Macédoine du Nord", dial: "+389", iso: "MK", flag: "🇲🇰" },
  { name: "Monténégro", dial: "+382", iso: "ME", flag: "🇲🇪" },
  { name: "Moldavie", dial: "+373", iso: "MD", flag: "🇲🇩" },
  { name: "Lituanie", dial: "+370", iso: "LT", flag: "🇱🇹" },
  { name: "Lettonie", dial: "+371", iso: "LV", flag: "🇱🇻" },
  { name: "Estonie", dial: "+372", iso: "EE", flag: "🇪🇪" },
  { name: "Liechtenstein", dial: "+423", iso: "LI", flag: "🇱🇮" },
  { name: "Jordanie", dial: "+962", iso: "JO", flag: "🇯🇴" },
  { name: "Bahreïn", dial: "+973", iso: "BH", flag: "🇧🇭" },
  { name: "Oman", dial: "+968", iso: "OM", flag: "🇴🇲" },
  { name: "Pakistan", dial: "+92", iso: "PK", flag: "🇵🇰" },
  { name: "Bangladesh", dial: "+880", iso: "BD", flag: "🇧🇩" },
  { name: "Sri Lanka", dial: "+94", iso: "LK", flag: "🇱🇰" },
  { name: "Kenya", dial: "+254", iso: "KE", flag: "🇰🇪" },
  { name: "Ghana", dial: "+233", iso: "GH", flag: "🇬🇭" },
  { name: "Gabon", dial: "+241", iso: "GA", flag: "🇬🇦" },
  { name: "Congo", dial: "+242", iso: "CG", flag: "🇨🇬" },
  { name: "RD Congo", dial: "+243", iso: "CD", flag: "🇨🇩" },
  { name: "Madagascar", dial: "+261", iso: "MG", flag: "🇲🇬" },
  { name: "Maurice", dial: "+230", iso: "MU", flag: "🇲🇺" },
];
